import { bankInfoSchema, homeAddressSchema, identitySchema, incomeDetailSchema, incomeSchema, welcomePageSchema, spousalSchema, spousalAddressSchema, tcpaPageSchema, personalInfoPageSchema } from './pages/registration';
import { getLinkSchema } from './pages/getLink';
export default {
    registration: {
        welcomePageSchema,
        homeAddressSchema,
        identitySchema,
        incomeSchema,
        incomeDetailSchema,
        bankInfoSchema,
        spousalSchema,
        spousalAddressSchema,
        tcpaPageSchema,
        personalInfoPageSchema
    },
    getLink: getLinkSchema,
    portal: []
};
